import { getRandomId, getValueType, hasOwnProperty, isArray, isArrayLike, isPlainObject, isPrototype, makePrimitiveValue, } from './utils';
export class Atom {
    store = {};
    getStore() {
        return this.store;
    }
    resetStore() {
        this.store = {};
    }
    // { __atomId: instanceId }
    instanceStore = {};
    getInstanceStore() {
        return this.instanceStore;
    }
    resetInstanceStore() {
        this.instanceStore = {};
    }
    transformToAtom(data, serializeData = false) {
        const { value, ok } = makePrimitiveValue(data);
        const id = getRandomId();
        if (ok) {
            return {
                id,
                type: getValueType(data),
                value,
            };
        }
        if (serializeData) {
            try {
                return {
                    id,
                    type: 'json',
                    value: JSON.stringify(data),
                };
            }
            catch (e) {
                // type === 'json' && value === null 作为无法序列化数据时的硬编码
                return {
                    id,
                    type: 'json',
                    value: null,
                };
            }
        }
        return this.add(data);
    }
    get(id) {
        const cacheData = this.store[id];
        const instanceId = this.instanceStore[id];
        if (!cacheData)
            return null;
        const result = {};
        const descriptors = Object.getOwnPropertyDescriptors(cacheData);
        Object.keys(descriptors).forEach((key) => {
            const desc = descriptors[key];
            if (hasOwnProperty(desc, 'value')) {
                desc.value = this.transformToAtom(desc.value);
            }
            result[key] = Atom.getAtomOverview({
                atomId: getRandomId(),
                instanceId,
                value: desc,
            });
        });
        const extraProps = this.addExtraProperty(id);
        return {
            ...result,
            ...extraProps,
        };
    }
    /* c8 ignore start */
    getOrigin(id) {
        const value = this.store[id];
        if (!value)
            return null;
        return value;
    }
    /* c8 ignore stop */
    add(data, insId = '') {
        const id = getRandomId();
        let instanceId = id;
        // must provide the instance id if the `isPrototype(data)` return true,
        // or else will occur panic when access the property along the proto chain
        if (isPrototype(data)) {
            instanceId = insId;
        }
        this.store[id] = data;
        this.instanceStore[id] = instanceId;
        const name = Atom.getSemanticValue(data);
        return Atom.getAtomOverview({ atomId: id, value: name, instanceId });
    }
    static getAtomOverview({ instanceId = '', atomId, value, }) {
        const id = getRandomId();
        return {
            id,
            type: 'atom',
            __atomId: atomId,
            instanceId,
            value,
        };
    }
    static getSemanticValue(data) {
        if (isPlainObject(data)) {
            return 'Object {...}';
        }
        if (isArray(data)) {
            return `Array (${data.length})`;
        }
        const constructorName = data.constructor.name;
        return constructorName;
    }
    addExtraProperty(id) {
        const data = this.store[id];
        const instanceId = this.instanceStore[id];
        const result = {};
        if (data instanceof String ||
            data instanceof Number ||
            data instanceof Boolean) {
            result['[[PrimitiveValue]]'] = this.transformToAtom(data.valueOf());
        }
        if (data instanceof Set) {
            const entries = {};
            let index = 0;
            for (const v of data) {
                entries[index++] = v;
            }
            entries.size = data.size;
            result['[[Entries]]'] = this.transformToAtom(entries);
        }
        if (data instanceof Map) {
            const entries = {};
            let index = 0;
            for (const [k, v] of data.entries()) {
                entries[index++] = {
                    key: k,
                    value: v,
                };
            }
            entries.size = data.size;
            result['[[Entries]]'] = this.transformToAtom(entries);
        }
        /* c8 ignore next 3 */
        if (isArray(data) || isArrayLike(data)) {
            result.length = this.transformToAtom(data.length);
        }
        if (Object.getPrototypeOf(data) !== null) {
            result['[[Prototype]]'] = this.add(Object.getPrototypeOf(data), instanceId);
        }
        else {
            // eslint-disable-next-line no-underscore-dangle
            result.___proto___ = this.transformToAtom(null);
        }
        return result;
    }
}
export const atom = new Atom();
